"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withToc = exports.insertToc = exports.isTocElement = void 0;
const slate_1 = require("slate");
const voidInsert_1 = require("./voidInsert");
const isTocElement = (node) => slate_1.Element.isElement(node) && node.type === 'toc';
exports.isTocElement = isTocElement;
const createTocElement = (overrides = {}) => {
    const children = [{ text: '' }];
    return {
        type: 'toc',
        children,
        ...overrides,
    };
};
const insertToc = (editor, overrides = {}) => (0, voidInsert_1.insertVoidBlock)(editor, createTocElement(overrides));
exports.insertToc = insertToc;
const withToc = (editor) => {
    const { isVoid } = editor;
    editor.isVoid = (element) => (element.type === 'toc' ? true : isVoid(element));
    return editor;
};
exports.withToc = withToc;
